export const temuApp = {
  id: 98,
  name: "temu",
  label: "Temu",
  isMarketplace: true,
  // The wizard only continues after a passed credentials check (CONNECT-6883).
  // Temu signs every call with an MD5 over its whole body, which a static request
  // cannot express, so authType "temu" makes the backend run the connector's own
  // check (bg.open.accesstoken.info.get: app key, secret, signature and token in
  // one call, plus local-shop and order-scope checks).
  showTestConnection: true,
  additional_params: {
    authType: "temu"
  },
  // Editing any of these after a passed check invalidates it.
  testConnectionFields: ["region", "appKey", "appSecret", "accessToken"],
  logo: process.env.BASE_URL + "media/shopLogos/temu.svg",
  // Migration is off: there is no legacy Temu interface to migrate from
  // (CONNECT-6899). Reporting is not part of the MVP scope.
  areaBlacklist: ["migration", "reporting"],
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_TEMU_PRESET_ID,
    // No product entry: the form config offers no product feature yet, because
    // listings need the category and attribute adapter first (CONNECT-6885).
    testWorkflows: {
      salesOrder: process.env?.VUE_APP_SCM_APP_TEMU_TEST_ORDER_WORKFLOW_ID,
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      prices: process.env?.VUE_APP_SCM_APP_TEST_PRICES_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_TRACKING_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_TEMU_TEST_BATCH_ORDER_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_BATCH_TRACKING_WORKFLOW_ID
    },
    CFLDataSetId: process.env?.VUE_APP_SCM_APP_TEMU_REPORTING_CFL_DATASET_ID,
    syncBatchWorkflowId:
      process.env?.VUE_APP_SCM_APP_TEMU_REPORTING_SYNC_BATCH_WORKFLOW_ID
  }
};
